import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgIconComponent } from './pg-icon.component';

@NgModule({
  imports: [CommonModule],
  declarations: [PgIconComponent],
  exports: [PgIconComponent],
})
export class PgIconModule {}
